export default {
    'add-new-exam': 'إضافة اختبار جديد',
    'edit-exam': 'تعديل الاختبار',
    'exam-link': 'رابط الاختبار',
    'the-exam': 'الاختبار',
    'exam-is-added': 'تم إضافة الاختبار',
    'exam-is-edited': 'تم تعديل الاختبار',
}
